export { default } from "./DetallesVenta";
